"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppState = void 0;
var AppState;
(function (AppState) {
    let fotoFrontal = null;
    let fotoPosterior = null;
    let fotoFrontalCapturada = false;
    let fotoPosteriorCapturada = false;
    let camaraIniciar = 'frontal';
    AppState.setFotoFrontal = (fotoURL) => {
        fotoFrontal = fotoURL;
    };
    AppState.setFotoPosterior = (fotoURL) => {
        fotoPosterior = fotoURL;
    };
    AppState.setFotoFrontalCapturada = (capturada) => {
        fotoFrontalCapturada = capturada;
    };
    AppState.setFotoPosteriorCapturada = (capturada) => {
        fotoPosteriorCapturada = capturada;
    };
    AppState.setCamaraIniciar = (camara) => {
        camaraIniciar = camara;
    };
    AppState.getFotoFrontal = () => fotoFrontal;
    AppState.getFotoPosterior = () => fotoPosterior;
    AppState.getFotoFrontalCapturada = () => fotoFrontalCapturada;
    AppState.getFotoPosteriorCapturada = () => fotoPosteriorCapturada;
    AppState.getCamaraIniciar = () => camaraIniciar;
    AppState.reset = () => {
        fotoFrontal = null;
        fotoPosterior = null;
        fotoFrontalCapturada = false;
        fotoPosteriorCapturada = false;
        camaraIniciar = 'frontal';
    };
})(AppState || (exports.AppState = AppState = {}));
